import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import type { Theme } from "@mui/material";
import { INK } from "@/theme/tokens";
import type { MetaChipTone } from "./Badges/MetaChip";

/** Which way a measure moved. */
export enum TrendDirection {
	Up = "up",
	Down = "down",
	Flat = "flat",
}

/**
 * Whether a change is good news, bad news, or neither. Separate from `TrendDirection` because the two disagree:
 * overtime going up is bad, cost going down is good, headcount moving is neither. The caller states the meaning.
 */
export enum TrendSentiment {
	Good = "good",
	Bad = "bad",
	Neutral = "neutral",
}

export const TREND_DIRECTION_ICON: Record<TrendDirection, typeof ArrowUpwardRoundedIcon> = {
	[TrendDirection.Up]: ArrowUpwardRoundedIcon,
	[TrendDirection.Down]: ArrowDownwardRoundedIcon,
	[TrendDirection.Flat]: RemoveRoundedIcon,
};

export const TREND_SENTIMENT_CHIP_TONE: Record<TrendSentiment, MetaChipTone> = {
	[TrendSentiment.Good]: "success",
	[TrendSentiment.Bad]: "error",
	[TrendSentiment.Neutral]: "neutral",
};

/**
 * The ink a sentiment is drawn in. Neutral is quiet ink, never the brand: on a green or teal tenant a brand-coloured
 * "neither" reads as good news, and brand is what the app uses to mean "you can click this".
 */
export const trendSentimentColor = (theme: Theme, sentiment: TrendSentiment): string => {
	if (sentiment === TrendSentiment.Good) return theme.palette.success.main;
	if (sentiment === TrendSentiment.Bad) return theme.palette.error.main;
	return INK.SECONDARY;
};
